import CircularProgress from '@mui/material/CircularProgress';
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const Spinner = (props) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress  {...props} />
            {/* <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="caption" component="div" color="text.secondary">
              {`${Math.round(props.value)}%`}
            </Typography>
          </Box> */}
        </Box>
    );
};

export default Spinner;
